import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Twitter, Github, FileText, Send } from 'lucide-react';

const footerLinks = {
  product: [
    { label: 'Main Site', href: 'https://neuro-mesh.io', external: true },
    { label: 'Build Agent', href: 'https://app.neuro-mesh.io', external: true },
    { label: 'Whitepaper', href: 'https://neuromesh.gitbook.io/neuromesh/', external: true },
    { label: 'Documentation', href: '#', external: false },
  ],
  tokenomics: [
    { label: 'Distribution', href: '#distribution', external: false },
    { label: 'Vesting Schedule', href: '#vesting', external: false },
    { label: 'TGE Supply', href: '#tge', external: false },
    { label: 'Download CSV', href: '#data', external: false },
  ],
  community: [
    { label: 'Twitter', href: 'https://x.com/meshneuro', external: true, icon: Twitter },
    { label: 'Telegram', href: '#', external: true, icon: Send },
    { label: 'GitHub', href: '#', external: true, icon: Github },
    { label: 'Blog', href: '#', external: true, icon: FileText },
  ],
};

export const Footer = () => {
  return (
    <footer className="relative border-t border-border/50 bg-background/50">
      {/* Neural line separator */}
      <div className="absolute top-0 left-0 right-0 h-px neural-line" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_neuromesh-token/artifacts/xe1d400s_NeuroMesh%20Logo%20%282%29.png" 
                alt="NeuroMesh Logo" 
                className="w-10 h-10 rounded-lg object-contain"
              />
              <div>
                <span className="font-heading font-semibold text-foreground">
                  NeuroMesh
                </span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              The Intelligence Layer of On-Robot Compute. 
              Fair-launch oriented tokenomics with high float and deep liquidity.
            </p>
            <p className="text-xs text-muted-foreground/60">
              © 2024 NeuroMesh. All rights reserved.
            </p>
          </div>
          
          {/* Product Links */}
          <div>
            <h4 className="font-heading font-semibold text-foreground mb-4">Product</h4>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <a 
                    href={link.href}
                    target={link.external ? '_blank' : undefined}
                    rel={link.external ? 'noopener noreferrer' : undefined}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-1.5"
                  >
                    {link.label}
                    {link.external && <ExternalLink className="w-3 h-3" />}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Tokenomics Links */}
          <div>
            <h4 className="font-heading font-semibold text-foreground mb-4">Tokenomics</h4>
            <ul className="space-y-3">
              {footerLinks.tokenomics.map((link) => (
                <li key={link.label}>
                  <a 
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Community Links */}
          <div>
            <h4 className="font-heading font-semibold text-foreground mb-4">Community</h4>
            <ul className="space-y-3">
              {footerLinks.community.map((link) => {
                const Icon = link.icon;
                return (
                  <li key={link.label}>
                    <a 
                      href={link.href}
                      target={link.external ? '_blank' : undefined}
                      rel={link.external ? 'noopener noreferrer' : undefined}
                      className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
                    >
                      {Icon && <Icon className="w-4 h-4" />}
                      {link.label}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-border/50 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground/60 text-center md:text-left">
            $NEURO token information is for educational purposes only. Not financial advice.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
